import { Component, Input } from '@angular/core';
import { FileStatus } from 'src/app/enums/file.status';
import { SagepayExportLogStatus } from 'src/app/enums/sagepay.export.log.status';
import { TransactionStatus } from 'src/app/enums/transaction.status';
import { UserStatus } from 'src/app/enums/user.status';

@Component({
    selector: 'app-account-status',
    templateUrl: './account-status.component.html',
    styleUrls: ['./account-status.component.css'],
})
export class AccountStatusComponent {
    @Input() type = 'user';
    @Input() accounts: any;
    @Input() cssClass = '';
    @Input() status: string;
    @Input() businessStatus: string;
    @Input() agentStatus: string;
    @Input() enterpriseStatus: string;
    @Input() employeeStatus: string;
    @Input() staffStatus: string;
    @Input() smartSafeStatus: string;
    @Input() safeStatus: string;
    @Input() transactionStatus: string;
    userStatusEnum = UserStatus;
    fileStatusEnum = FileStatus;
    transactionStatusEnum = TransactionStatus;
    sagepayExportLogStatus = SagepayExportLogStatus;

    constructor() { }

    userStatusBlocks() {
        const blocks = [];

        if (this.accounts?.cit)
            blocks.push({ label: 'CIT', status: this.accounts?.cit });

        if (this.accounts?.personal)
            blocks.push({ label: 'Personal User', status: this.status });

        if (this.accounts?.business)
            blocks.push({ label: 'Business User', status: this.businessStatus });

        if (this.accounts?.agent)
            blocks.push({ label: 'Agent', status: this.agentStatus });

        if (this.enterpriseStatus)
            blocks.push({ label: 'Enterprise', status: this.enterpriseStatus });

        if (this.staffStatus)
            blocks.push({ label: 'Staff User', status: this.staffStatus });

        if (this.employeeStatus)
            blocks.push({
                label: this.employeeStatus === 'disabled' ? 'Deactivated' : 'Active',
                status: this.employeeStatus
            });

        if (this.smartSafeStatus)
            blocks.push({ label: '', status: this.smartSafeStatus });

        return blocks;
    }

    fileBlocks() {
        const blocks = [];

        if (this.status)
            blocks.push({ label: 'Personal User Identity', status: this.status });

        if (this.businessStatus)
            blocks.push({ label: 'Business User Identity', status: this.businessStatus });

        if (this.agentStatus)
            blocks.push({ label: this.status, status: this.agentStatus });

        return blocks;
    }

}
